export default {
  // General UI elements
  save: "保存",
  saving: "保存中",
  cancel: "キャンセル",
  edit: "編集",
  delete: "削除",
  profile: "プロフィール",
  settings: "設定",
  logout: "ログアウト",
  language: "言語",
  loading: "読み込み中",
  submit: "送信",
  search: "検索...",
  back: "戻る",
  next: "次へ",
  previous: "前へ",
  continue: "続ける",
  done: "完了",
  error: "エラー",
  success: "成功",
  warning: "警告",
  info: "情報",
  close: "閉じる",
  open: "開く",
  yes: "はい",
  no: "いいえ",
  ok: "OK",
   
  // Authentication
  auth: {
    signIn: "ログイン",
    signUp: "登録",
    signOut: "ログアウト",
    forgotPassword: "パスワードをお忘れですか？",
    resetPassword: "パスワードをリセット",
    sendResetLink: "リセットリンクを送信",
    createAccount: "アカウント作成",
    alreadyHaveAccount: "すでにアカウントをお持ちですか？",
    dontHaveAccount: "アカウントをお持ちでないですか？",
    or: "または",
    continueWith: "続行",
    google: "Google",
    facebook: "Facebook",
    apple: "Apple",
    twitter: "Twitter",
    passwordRequirements: "パスワードは8文字以上である必要があります",
    passwordMatch: "パスワードが一致する必要があります",
    emailInvalid: "有効なメールアドレスを入力してください"
  },
  
  // Profile specific
  username: "ユーザー名",
  email: "メールアドレス",
  password: "パスワード",
  confirmPassword: "パスワードを確認",
  joinDate: "登録日",
  streak: "連続記録",
  xp: "XP",
  plan: "プラン",
  free: "無料",
  pro: "プロ",
  premium: "プレミアム",
  referralCode: "紹介コード",
  share: "共有",
  copy: "コピー",
  copied: "コピーしました！",
  contactUs: "お問い合わせ",
  termsOfService: "利用規約",
  privacyPolicy: "プライバシーポリシー",
  accountSettings: "アカウント設定",
  changePassword: "パスワード変更",
  deleteAccount: "アカウント削除",
  deleteAccountConfirm: "本当にアカウントを削除しますか？この操作は元に戻せません。",
  updateProfile: "プロフィール更新",
  profileUpdated: "プロフィールが正常に更新されました",
  memberSince: "登録日",
  noSetsYet: "まだセットがありません :(",
  upgradeToPro: "プロにアップグレード",
  recentActivity: "最近のアクティビティ",
  shareWithAFriend: "友達と共有",
  contactTheTeam: "チームに連絡する",
  termsAndConditions: "利用規約",
  editUsername: "ユーザー名を編集:",
  logOut: "ログアウト",
  usernameError1: "ユーザー名を入力してください",
  usernameError2: "別の新しいユーザー名を入力してください",
  usernameError3: "ユーザー名にスペースを含めることはできません",
  usernameError4: "ユーザー名に大文字を含めることはできません",
  usernameError5: "ユーザー名に特殊文字を含めることはできません",
  usernameError6: "ユーザー名は4〜18文字である必要があります",
  usernameError7: "ユーザー名に不適切な内容が含まれています",
  usernameError8: "このユーザー名はすでに使用されています",
  clickOrDragAndDrop: "クリックまたはドラッグ&ドロップしてアップロード",
  confirm: "確認",
  retake: "再撮影",

  // BottomNav
  profile: "プロフィール",
  home: "ホーム",
  library: "マイライブラリ",
  saved: "保存済み",
  rankings: "ランク",

  // Feature
  backToLibrary: "ライブラリに戻る",
  exploreSets: "セットを探索",
  communitySets: "コミュニティーセット",
  mySets: "マイセット",
  alreadyAdded: "既に追加しました",
  addToLibrary: "ライブラリに追加",
  loading: "読み込み中...",
  loadMoreSets: "さらにセットを読み込む",
  by: "作成者",
  makePublic: "パブリックにする",
  subscriptionRequired: "サブスクリプションが必要です",
  subscriptionRequiredMessage: "ライブラリには10セットまで同時に追加できます。プレミアムにアップグレードして無制限のセットを追加してください！",

  // My Library
  deleteSet: "セットを削除",
  deleteSetConfirmation: "このセットを削除してもよろしいですか？",
  yesDelete: "はい、削除",
  collections: "パブリックセット",
  myLibrary: "マイライブラリ",
  outOf10Sets: "10セットのうち追加済み",
  switchBackToPro: "プロに戻す",
  upgradeToPro: "プロにアップグレード",
  outOf10OnFree: "10セットのうち無料で追加済み.",
  letMeCook: "料理を任せてください",
  selectMode: "モードを選択",
  multipleChoice: "複数選択",
  flashcards: "フラッシュカード",
  freeResponse: "フリーレスポンス",
  proOnly: "プロ限定",
  leaderboard: "リーダーボード",
  favorites: "お気に入り",
  profile: "プロフィール",
  reportBugs: "バグを報告",

  // Question Card
  correctMessage: "正解！料理を任せていただきました。",
  typeYourAnswer: "回答を入力してください...",
  submitAnswer: "回答を送信",
  responseCannotBeBlank: "回答を入力してください",
  noAnswerAvailable: "回答がありません",
  answerGuideline: "回答のガイドライン:",
  pleaseSubmitAnswerFirst: "回答を送信してください",
  revealAnswer: "回答を表示",
  hideAnswer: "回答を隠す",
  gradingInProgress: "採点中...",
  grading: "採点",
  answerGuidelines: "回答ガイドライン",
  finalScore: "最終スコア:",
  evaluateAnswer: "回答を評価",

  // Saved
  favorites: "お気に入り",
  searchQuestions: "問題を検索...",
  noSavedQuestions: "まだ保存した問題はありません。",

  // Scroller
  loadingMoreQuestions: "さらに問題を読み込み中",

  // New Prompt
  deleteSet: "セットを削除",
  deleteSetConfirmation: "このセットを削除してもよろしいですか？",
  yesDelete: "はい、削除",
  cancel: "キャンセル",
  setLimitReached: "セットの上限に達しました",
  setLimitError: "ライブラリには最大10セットまでしか追加できません。プロにアップグレードして無制限にセットを追加してください！",
  close: "閉じる",
  uploadNotes: "ノートをアップロード",
  general: "一般",
  title: "タイトル",
  setTitleMessage: "AIが生成したCookrの問題にタイトルを設定してください。後で簡単にアクセスできるようにするためです。",
  titleError1: "タイトルを入力してください",
  titleError2: "タイトルに不適切な内容が含まれています",
  content: "コンテンツ",
  setContentMessage: "ノート、レクチャー、またはその他のテキストコンテンツをコピーして貼り付けます。",
  contentError1: "コンテンツを入力してください",
  contentError2: "コンテンツに不適切な内容が含まれています",
  subject: "主題",
  setSubjectMessage: "このコンテンツの主題またはトピックは何ですか？",
  subjectError1: "主題を入力してください",
  subjectError2: "主題に不適切な内容が含まれています",

  // Payment Confirmation
  returnToProfile: "プロフィールに戻る",

  // Plans
  confirmSwitch: "無料プランへの切り替えを確認",
  confirmSwitchMessage: "無料プランに切り替えることを確認しますか？プレミアム機能へのアクセスが失われます。",
  buttonConfirm: "切り替えを確認",
  processing: "処理中...",
  unlimitedScrolling: "無制限スクロール",
  unlimitedSubjects: "無制限の主題",
  aiTutorBot: "AI チューター ボット",
  newFeatureAccess: "新しい機能へのアクセス",
  saveScrolls: "スクロールを保存",
  infiniteNoteUploads: "無制限のノートアップロード",
  answerExplanations: "回答の説明",
  shareScrolls: "スクロールを共有",
  everythingInStandard: "すべてのスタンダード",
  current: "現在",
  switchOver: "切り替える",
  forever: "/永遠に",
  monthly: "/月",
  yearly: "/年",

  // Leaderboard
  leaderboard: "リーダーボード",

  // Home.js
  pickASubject: "セッションを開始するには、トピックを選択してください！",

  // scrollerLoader
  generatingContent: "コンテンツを生成中...",

  // Dropdown
  choose: "選択",
  titleTooLong: "タイトルは100文字以内で入力してください",
}

